import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import {connect} from 'react-redux';
import {cssClassMap} from 'rendering-commons/SportCssMap';

import PopularMatchRate from '../popular-match-rate/PopularMatchRate.jsx';
import localeMap from 'constants/Locales'

class PopularMatch extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        sport: React.PropTypes.object,
        league: React.PropTypes.object,
        match: React.PropTypes.object,
        rates: React.PropTypes.array
    };

    constructor(props) {
        super(props);

        this.renderMatchDate = this.renderMatchDate.bind(this);
    }

    static renderRates(rates, gridLocalization) {
        const size = rates.length;

        const win1Rate = rates[0].get('id');
        const drawRate = size === 3 ? rates[1].get('id') : undefined;
        const win2Rate = rates[size - 1].get('id');

        return (
            <span className="cell-title-wrapper">
                <PopularMatchRate key="0" id={win1Rate} section="popularMatches" gridLocalization={gridLocalization} />
                <PopularMatchRate key="1" id={drawRate} section="popularMatches" gridLocalization={gridLocalization} />
                <PopularMatchRate key="2" id={win2Rate} section="popularMatches" gridLocalization={gridLocalization} />
            </span>
        );
    }

    renderMatchDate(date) {
        const timezone = moment.tz.guess();

        const locale = localeMap[this.props.languageId];
        moment.locale(locale);

        moment.updateLocale('en', {
            calendar: {
                sameDay: '[Today at] HH:mm',
                nextDay: '[Tomorrow at] HH:mm',
                lastWeek: 'D MMMM [at] HH:mm',
                nextWeek: 'D MMMM [at] HH:mm',
                sameElse: 'D MMMM [at] HH:mm'
            }
        });

        moment.updateLocale('ru', {
            calendar: {
                sameDay: '[Сегодня в] HH:mm',
                nextDay: '[Завтра в] HH:mm',
                lastWeek: 'D MMMM [в] HH:mm',
                nextWeek: 'D MMMM [в] HH:mm',
                sameElse: 'D MMMM [в] HH:mm'
            }
        });

        date.locale(locale).tz(timezone);

        return (
            <span className="event__date">
                {date.calendar()}
            </span>
        );
    }

    render() {
        const {sport, league, match, rates, gridLocalization} = this.props;

        if (!sport) {
            return false;
        }

        const iconCls = 'sport-icon svg-' + cssClassMap[sport.get('id')];

        const channel = match.get('channel');

        let name = match.get('name');
        const notice = match.get('notice');
        if (notice) {
            name = `${name} (${notice})`;
        }

        const outcomesCount = match.get('outcomesCount') > 1 ? match.get('outcomesCount') - 1 : false;

        return (
            <div className="table popular--table">
                <div className="row">
                    <span className="cell main">
                        <span className="event-name popular--event-name">
                            {this.renderMatchDate(match.get('startDate'))}
                            <Link to={`/sports/${sport.get('id')}/${league.get('id')}/${match.get('id')}`}
                                  className="event-name__link">
                                <div className="hint hint--league">
                                    {league.get('name')}
                                </div>
                                <span className={iconCls}/>
                                {name}
                                {channel && <sup className="icon icon--tv" title={channel}>{' '}</sup>}
                            </Link>
                            {outcomesCount &&
                            <Link to={`/sports/${sport.get('id')}/${league.get('id')}`}
                                  className="outcome-count" >+{outcomesCount}</Link>}
                        </span>
                        <span className="cell-main tools"/>
                    </span>
                    <span>
                        {PopularMatch.renderRates(rates, gridLocalization)}
                    </span>
                </div>
            </div>
        );
    }
}

function select(state, props) {
    const match = props.match;
    const matchId = match.get('id');

    const languageId = state.application.get('languageId');
    const sports = state.application.getIn(['popularMatches', 'sports']);
    const leagues = state.application.getIn(['popularMatches', 'leagues']);
    const rates = state.application.getIn(['popularMatches', 'rates']);

    const matchRates = rates.valueSeq()
        .filter(r => r.get('matchId') === matchId)
        .sort((a, b) => {
            if (a.get('type') > b.get('type')) {
                return 1;
            } else {
                return -1;
            }
        })
        .toArray();

    return {
        languageId,
        match,
        sport: sports.getIn([match.get('sportId')]),
        league: leagues.getIn([match.get('leagueId')]),
        rates: matchRates
    };
}

export default connect(select)(PopularMatch);



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/popular-match/PopularMatch.jsx